module.exports = __webpack_public_path__ + "static/media/Philm.36619f37.md";